export default {"src":"/_next/static/media/tab_list.9e0ef6f6.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};